import styled from 'styled-components'

export const SuccessMessage = styled.div`
  overflow-wrap: break-word;
  font-weight: 500;
  font-size: 14px;
  color: ${(props) => props.theme.colors.semantic.valid};
`
